// Development-only diagnostics. Silenced in production builds so no
// request/tenant detail ever reaches the browser console of a real user.
const isDev = process.env.NODE_ENV !== "production";

export const devLog = (...args) => { if (isDev) console.debug(...args); };
export const devWarn = (...args) => { if (isDev) console.warn(...args); };
export const devError = (...args) => { if (isDev) console.error(...args); };
